import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a read icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <ReadIcon width={12} />
 */
function ReadIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d={`M22 12C22 13.9778 21.4135 15.9112 20.3147 17.5557C19.2159 19.2002 17.6541 20.4819 15.8268
                21.2388C13.9996 21.9957 11.9889 22.1937 10.0491 21.8079C8.10929 21.422 6.32746 20.4696 4.92894
                19.0711C3.53041 17.6725 2.578 15.8907 2.19215 13.9509C1.8063 12.0111 2.00433 10.0004 2.76121
                8.17317C3.51809 6.3459 4.79981 4.78412 6.4443 3.6853C8.08879 2.58649 10.0222 2 12 2C14.6522 2
                17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12ZM10.03 17C10.167 16.9964
                10.3018 16.9644 10.4258 16.9058C10.5498 16.8473 10.6602 16.7636 10.75 16.66L17.75 8.66C17.8435
                8.56264 17.9163 8.44736 17.9641 8.3211C18.0119 8.19484 18.0336 8.06022 18.0279 7.92535C18.0223
                7.79047 17.9894 7.65814 17.9312 7.53633C17.873 7.41452 17.7908 7.30574 17.6894 7.21656C17.5881
                7.12738 17.4697 7.05965 17.3415 7.01743C17.2133 6.97522 17.0779 6.9594 16.9434 6.97093C16.8089
                6.98247 16.6781 7.02111 16.5589 7.08454C16.4398 7.14797 16.3347 7.23487 16.25 7.34L9.95 14.54L7.71
                12.3C7.62036 12.1953 7.51004 12.1103 7.38597 12.0503C7.26191 11.9903 7.12678 11.9565 6.98906
                11.9512C6.85134 11.9459 6.71401 11.9691 6.58568 12.0194C6.45736 12.0696 6.34081 12.1459 6.24335
                12.2434C6.1459 12.3408 6.06964 12.4574 6.01937 12.5857C5.96909 12.714 5.94589 12.8513 5.95121
                12.9891C5.95653 13.1268 5.99026 13.2619 6.05028 13.386C6.1103 13.51 6.19532 13.6204 6.3 13.71L9.3
                16.71C9.4868 16.8939 9.73786 16.9979 10 17H10.03Z`}
            />
        </SvgIcon>
    )
}

ReadIcon.defaultProps = defaultProps

export { ReadIcon }
